import type { AnswerState } from '@repo/contracts/cardfinder/funnel/types';
import { createServerSession, writeServerSession } from '@/entities/session/api/sessionDAL';
import type { SessionSaveOutcome } from '@/entities/session/api/sessionWriteResult';
import type { CardfinderSessionStatus } from '@/shared/api/db/tables';
import {
  markLocalSessionInProgress,
  readLocalSession,
  resetLocalSession,
} from '../model/localSession';

async function performSave(
  answers: AnswerState,
  status: CardfinderSessionStatus,
  funnelConfigVersion: string | undefined,
): Promise<SessionSaveOutcome> {
  const local = readLocalSession();

  if (local && local.kind !== 'recovered') {
    const result = await writeServerSession(local.id, answers, { status, funnelConfigVersion });

    if (result === 'not-found' || result === 'invalid-token') {
      resetLocalSession();
      return performSave(answers, status, funnelConfigVersion);
    }
    return { result, sessionId: local.id };
  }

  const outcome = await createServerSession(answers, status, funnelConfigVersion);

  if (outcome.sessionId) markLocalSessionInProgress(outcome.sessionId);
  return outcome;
}

export function saveFunnelSession(
  answers: AnswerState,
  options?: { status?: CardfinderSessionStatus; funnelConfigVersion?: string },
): Promise<SessionSaveOutcome> {
  if (typeof window === 'undefined') return Promise.resolve({ result: 'ok', sessionId: null });

  return performSave(answers, options?.status ?? 'incomplete', options?.funnelConfigVersion);
}
